import { PluginKey } from '@atlaskit/editor-prosemirror/state';

export const codeBidiWarningPluginKey: PluginKey = new PluginKey('codeBidiWarningPlugin');
